"use client";

import * as React from "react";
import { Select } from "./elements.js";
import { useUsersManagementContext } from "./users-management-context.js";
import { MemberRole } from "../api/endpoint.js";

const ALL_ROLES_NAME = "All";
const ALL_ROLES_VALUE = "null";

type UsersFilterProps = React.ComponentPropsWithoutRef<typeof Select.Root> & {
  roles: MemberRole[] | undefined;
  disabled?: boolean;
};

export const UsersFilter: React.FC<UsersFilterProps> = ({
  roles,
  disabled,
}) => {
  const {
    dispatch,
    state: { role },
  } = useUsersManagementContext();

  const setFilterParams = (value: string | null) => {
    dispatch({ type: "FILTER_BY_ROLE", role: value });
  };
  const isValidRole = (value: unknown): value is string =>
    roles ? roles.findIndex((role) => role.slug === value) !== -1 : false;
  const filteredRole = isValidRole(role) ? role : ALL_ROLES_VALUE;
  const roleName =
    roles?.find((role) => role.slug === filteredRole)?.name || ALL_ROLES_NAME;

  const onValueChange = (value: string) => {
    if (value === ALL_ROLES_VALUE) {
      setFilterParams(null);
    } else {
      if (isValidRole(value)) {
        setFilterParams(value);
      }
    }
  };

  return (
    <Select.Root
      value={roles ? filteredRole : "null"}
      onValueChange={onValueChange}
      disabled={disabled}
    >
      <Select.Trigger>{roles ? roleName : ALL_ROLES_NAME}</Select.Trigger>
      <Select.Content>
        <Select.Item value={ALL_ROLES_VALUE}>{ALL_ROLES_NAME}</Select.Item>
        {roles?.map((role) => (
          <React.Fragment key={role.slug}>
            <Select.Item value={role.slug}>{role.name}</Select.Item>
          </React.Fragment>
        ))}
      </Select.Content>
    </Select.Root>
  );
};
